import axios from "../api";
/** Polled while `run.running`. */
export const getGalleryProgress = async () => {
    const res = await axios.get("/gallery/progress");
    return res.data;
};
/**
 * Queues solves for one set, one category's sets or (neither) every active
 * set, and returns at once. Category and all-set runs skip sets completed at S.
 */
export const startGallerySolves = async (scope) => {
    const res = await axios.post("/gallery/solutions", scope);
    return res.data;
};
/** Marks this grade and every grade below it completed; null clears them all. */
export const setGalleryCompletedGrade = async (setId, completedGrade) => {
    await axios.put(`/gallery/progress/${setId}`, { completedGrade });
};
//# sourceMappingURL=galleryProgress.js.map